// Mock data for North Lumé products and content

export const products = [
  {
    id: 1,
    name: "Zebra Blinds",
    description: "Blackout and light filtering options for perfect light control. Elegant dual-layer design combines style with functionality.",
    image: "https://images.unsplash.com/photo-1609534117141-ff9f20450902",
    features: ["Blackout Option", "Light Filtering", "Easy Operation"]
  },
  {
    id: 2,
    name: "Roman Blinds",
    description: "Classic elegance meets modern functionality. Soft fabric folds create a timeless, sophisticated look for any room.",
    image: "https://images.unsplash.com/photo-1609423433459-a65b330ef5da",
    features: ["Luxurious Fabrics", "Custom Patterns", "Cordless Options"]
  },
  {
    id: 3,
    name: "Vertical Blinds",
    description: "Perfect for large windows and sliding doors. Sleek design offers superior light control and privacy.",
    image: "https://images.unsplash.com/photo-1713370389454-f3adbac10520",
    features: ["Wide Coverage", "Smooth Operation", "Durable Materials"]
  },
  {
    id: 4,
    name: "Roller Shades",
    description: "Clean, minimalist design that complements any décor. Available in various opacity levels and designer fabrics.",
    image: "https://images.unsplash.com/photo-1662573559129-88c1d0c87ce7",
    features: ["Minimalist Style", "Multiple Opacities", "Space-Saving"]
  },
  {
    id: 5,
    name: "Honeycomb Shades",
    description: "Energy-efficient cellular design provides superior insulation. Reduces heating and cooling costs while adding elegance.",
    image: "https://images.unsplash.com/photo-1662109987496-e3c211fe2d38",
    features: ["Energy Efficient", "Sound Dampening", "Various Cell Sizes"]
  },
  {
    id: 6,
    name: "Plantation Shutters",
    description: "Timeless architectural beauty that enhances your home's value. Premium hardwood construction built to last generations.",
    image: "https://images.unsplash.com/photo-1770414173168-f6c666501225",
    features: ["Premium Hardwood", "Increases Home Value", "Lifetime Durability"]
  },
  {
    id: 7,
    name: "Motorized Blinds",
    description: "Smart home integration with effortless control. Schedule, voice activation, and remote operation for ultimate convenience.",
    image: "https://images.unsplash.com/photo-1610548320145-121f3af10432",
    features: ["Smart Home Ready", "Remote Control", "Voice Activated"]
  }
];

export const contactInfo = {
  email: "northlumeshades@gmail.com",
  phone: "+16138407558",
  phoneDisplay: "+1 613 840 7558",
  website: "www.northlume.ca",
  whatsapp: "16138407558"
};

export const features = [
  {
    title: "Custom Installation",
    description: "Professional installation tailored to your space",
    icon: "Ruler"
  },
  {
    title: "Free Measurements",
    description: "Complimentary in-home consultation and estimate",
    icon: "Home"
  },
  {
    title: "Premium Quality",
    description: "Only the finest materials and craftsmanship",
    icon: "Award"
  },
  {
    title: "Expert Consultation",
    description: "Personalized design guidance from our specialists",
    icon: "Users"
  }
];
